import { selectKoreUserData } from "ducks/selectors/koreCustomerData";
import { makeSelectzEIdentifyUserData } from "ducks/selectors";
import React, { useEffect } from "react";
import { Box, Flex } from "ui-components";
import { activateZendeskWidget } from "utils/helpers";
import get from "lodash/get";
import { connect } from "react-redux";
import { compose } from "redux";
import { useSelector } from "react-redux";
import { createStructuredSelector } from "reselect";

const layoutStyles = {
  maxWidth: 700
};

function Chat(props) {
  const { zEIdentify, appSettings } = props;
  const koreUserData = useSelector(selectKoreUserData);
  const prefilzEForm = get(
    appSettings,
    "layout.header.help.prefilZendeskForm",
    true
  );

  useEffect(() => {
    showLiveChat();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [koreUserData]);

  const showLiveChat = () => {
    if (window.ENABLE_KORE_CHAT) {
      window.showKoreChat(koreUserData);
    } else if (prefilzEForm) {
      activateZendeskWidget(zEIdentify);
    } else {
      activateZendeskWidget();
    }
  };

  return (
    <div>
      <Flex justifyContent="center">
        <Box as="main" sx={layoutStyles}>
          <div className="flex font-semibold px-4">
            <span>
              To open our live chat, please click on the help icon above
            </span>
          </div>
        </Box>
      </Flex>
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  zEIdentify: makeSelectzEIdentifyUserData()
});

export function mapDispatchToProps(dispatch) {
  return {};
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps
});

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export default compose(withConnect)(Chat);
